import { render, staticRenderFns } from "./FinanceModule.vue?vue&type=template&id=10fa52d6&"
import script from "./FinanceModule.vue?vue&type=script&lang=js&"
export * from "./FinanceModule.vue?vue&type=script&lang=js&"
import style0 from "./FinanceModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports